import { IQueryMediator } from 'core-ts-types';
import { IDefineCommand } from 'core-ts-types';
import { APPlannedCourse, IAPPlannedCourseMeta } from '../../global/builders/ap_planned_course_builder';
import { APProgramSlot } from '../../global/builders/ap_program_slot_builder';
import { IAPPlannedCourseDataSource } from '../../global/datasources/ap_planned_course_datasource';
import { IAPProgramSlotDatasource } from '../../global/datasources/ap_program_slot_datasource';
import { IAPTermsDatasource } from '../../global/datasources/ap_terms_datasource';
import { INotificationDelegate } from '../../global/helpers/notification_delegate';
import { APCommandUrlServant } from '../../global/servants/ap_command_url_servant';

angular.module('capability-ng-academic-planner').service(
  'removeCourseFromTermCommand',
  /* tslint:disable:parameters-max-number */
  function removeCourseFromTermCommandDefinition(
    $http: ng.IHttpService,
    defineCommand: IDefineCommand,
    ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
    ngAPTermsDatasource: IAPTermsDatasource,
    ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
    QueryMediator: IQueryMediator,
    ngAPCommandUrlServant: APCommandUrlServant,
    $rootScope: ng.IRootScopeService,
    log: any,
    ngAPNotificationDelegate: INotificationDelegate
  ) {
    return defineCommand(
      'removeCourseFromTermCommand',
      function removeCourseFromTermCommand(
        deferred: any,
        program_slot: APProgramSlot,
        course: APPlannedCourse & IAPPlannedCourseMeta,
        isTermMove: boolean
      ) {
        const termId = course.term;
        const payload = {
          course_id: course.course,
          term_id: termId
        };

        // Emit message to planner on this channel to show saving message.
        $rootScope.$emit('my.planner.show.saving.message', termId);

        const academicPlanUrl = ngAPCommandUrlServant.get('academicPlan');

        $http
          .delete(academicPlanUrl, {
            data: payload
          })
          .then((response: any) => {
            if (isTermMove !== true) {
              ngAPPlannedCoursesDatasource.clear().write(response.data.planned_course);

              deferred.resolve(
                QueryMediator.runQueries(ngAPPlannedCoursesDatasource, ngAPProgramSlotDatasource, ngAPTermsDatasource)
              );
            } else {
              deferred.resolve();
            }
          })
          .catch((error) => {
            ngAPNotificationDelegate.error(`Failed to remove course from term`);
            log.issue('Failed to remove course from term');
            deferred.reject(error.data);
          });
      }
    );
  }
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/commands/remove_course_from_term_command.ts